import { AdminAuthProvider, useAdminAuth } from "./AdminAuthContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

function AdminRouter() {
  const { isAuthed } = useAdminAuth();
  return isAuthed ? <AdminDashboard /> : <AdminLogin />;
}

export default function AdminPage() {
  return (
    <AdminAuthProvider>
      <AdminRouter />
    </AdminAuthProvider>
  );
}
